import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=0129a840&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=js&"
export * from "./ProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=0129a840&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0129a840",
  null
  
)

export default component.exports